import { gql } from '@apollo/client';
import { rateUnitFragment } from 'helper/fragment';

export const INVOICES_QUERY = gql`
  ${rateUnitFragment}
  query invoices(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    invoices(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      invoices {
        id
        rateUnit {
          ...rateUnitInfo
        }
        createdAt
        total
        order {
          id
          seller {
            id
            firstName
            tradeName
            phone
          }
          buyer {
            id
            firstName
            tradeName
            phone
          }
        }
        invoiceStatus
        createdByUserId
        updatedByUserId
      }
      totalCount
      totalPages
    }
  }
`;

export const INVOICES_QUERY_SUBSCRIPTION = gql`
  ${rateUnitFragment}
  subscription invoices(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    invoices(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      invoice {
        id
        rateUnit {
          ...rateUnitInfo
        }
        createdAt
        total
        order {
          id
          seller {
            id
            firstName
            tradeName
            phone
          }
          buyer {
            id
            firstName
            tradeName
            phone
          }
        }
        invoiceStatus
        createdByUserId
        updatedByUserId
      }
      totalCount
      totalPages
      action
    }
  }
`;

export const DOWNLOAD_INVOICE = gql`
  query downloadInvoice($invoiceId: ID!) {
    downloadInvoice(invoiceId: $invoiceId)
  }
`;

// export const CREATE_INVOICES = gql`
//   mutation createInvoice(invoice: InvoiceInput) {
//     createInvoice(invoice: $invoice)
//   }
// `;
